import FilterList from "@mui/icons-material/FilterList";
import ViewColumn from "@mui/icons-material/ViewColumn";
import { Box, TextField, Tooltip } from "@mui/material";
import type { GridFilterModel } from "@mui/x-data-grid-pro";
import {
  ColumnsPanelTrigger,
  FilterPanelTrigger,
  Toolbar,
  ToolbarButton,
} from "@mui/x-data-grid-pro";
import { useDebouncedEffect } from "@react-hookz/web";
import { isEmpty } from "lodash-es";
import type { Dispatch, FC, SetStateAction } from "react";
import { useState } from "react";

export const SentMomentsTableToolbar: FC<{
  setFilterModel: Dispatch<SetStateAction<GridFilterModel>>;
}> = ({ setFilterModel }) => {
  return (
    <Toolbar>
      <Tooltip title="Columns">
        <ColumnsPanelTrigger render={<ToolbarButton size="small" />}>
          <ViewColumn fontSize="inherit" /> &#xA0; Columns
        </ColumnsPanelTrigger>
      </Tooltip>
      <Tooltip title="Filters">
        <FilterPanelTrigger render={<ToolbarButton size="small" />}>
          <FilterList fontSize="inherit" /> &#xA0; Filters
        </FilterPanelTrigger>
      </Tooltip>
      <Box sx={{ flexGrow: 1 }} />
      <SearchBar setFilterModel={setFilterModel} />
    </Toolbar>
  );
};

const SearchBar: FC<{ setFilterModel: Dispatch<SetStateAction<GridFilterModel>> }> = ({
  setFilterModel,
}) => {
  const [value, setValue] = useState("");

  useDebouncedEffect(
    () => {
      if (isEmpty(value)) {
        setFilterModel((prev) => ({
          ...prev,
          items: prev.items.filter((item) => item.field !== "moment_title"),
        }));
      } else {
        setFilterModel((prev) => ({
          ...prev,
          items: [
            ...prev.items.filter((item) => item.field !== "moment_title"),
            {
              id: "moment_title",
              field: "moment_title",
              operator: "contains",
              value,
            },
          ],
        }));
      }
    },
    [value, setFilterModel],
    500,
  );

  return (
    <TextField
      variant="standard"
      placeholder="Search"
      onChange={(e) => setValue(e.target.value)}
      defaultValue={value}
    />
  );
};
